import { defineComponent, getCurrentInstance, h, onBeforeUpdate, onMounted, onUnmounted, ref, Teleport } from 'vue'

import { mountedNodeRenderers } from './VueRenderer'

export default defineComponent({
  name: 'TipTapNodeRenderer',

  props: {
    componentProps: {
      default: () => ({}),
      type: Object
    },
    name: {
      default: 'default',
      type: String
    }
  },

  setup (props, context) {
    const tiptapNodeRenderer = getCurrentInstance()
    const vueRenderers = ref(([]))
    const vueRendererRefs = ref(new Map())

    onMounted(() => {
      if (!mountedNodeRenderers.has(props.name)) {
        mountedNodeRenderers.set(props.name, tiptapNodeRenderer)
      }
    })

    onUnmounted(() => {
      if (mountedNodeRenderers.has(props.name)) {
        mountedNodeRenderers.delete(props.name)
      }
    })

    onBeforeUpdate(() => {
      vueRendererRefs.value = new Map()
    })

    const addVueRenderer = (vueRenderer) => {
      vueRenderers.value.push(vueRenderer)
    }

    const deleteVueRenderer = (vueRenderer) => {
      const index = vueRenderers.value.indexOf(vueRenderer)
      if (index > -1) {
        vueRenderers.value.splice(index, 1)
      }
    }

    return {
      vueRenderers,
      vueRendererRefs,
      addVueRenderer,
      deleteVueRenderer
    }
  },

  render () {
    const components = []
    for (const vueRenderer of this.vueRenderers) {
      components.push(h(
        Teleport,
        { to: vueRenderer.element },
        h(
          vueRenderer.component,
          {
            ref: (el) => { this.vueRendererRefs.set(vueRenderer, el) },
            ...vueRenderer.props,
            ...this.componentProps
          }
        )
      ))
    }
    return components
  }
})
